<style lang="scss" scoped>
    @import "./checkPdf.css";
    #checkPdfpage .directory{
        width: 11rem
        // margin-left: 20px;
    }
    .titleCal{
        margin-left: 0.75rem;
    }
  
</style>
<style>
.hks_pc_div .contentPc{
    background: #f0f7f0;
}
</style>

<template>
	<div id='checkPdfpage' :class="{'o1_eng'  : ifEnglish}">
        <div>
            <div id="checkPdf" style="background:#ffffff">
                <div class="khtitleCla" style="background: #3d7077;">{{$t('login.khtitle')}}</div>
                <div style="display:flex;">
                    <directory></directory>
                    <div style="width:85%;">
                        <div class="titleCal" style="background: #3d7077;">
                            <img style="position: relative; top: 2px;" src="../../image/titleImg.png" alt="">
                            <span style="color:#ffffff;margin-left: 10px;">{{$t('khsm.wenti_a_2')}}</span>
                        </div>
                        <div class="checkCla hks_pc_div"  ref="viewBox">
                            <account/>
                        </div>
                    </div>
                </div>
                <!-- <div class="titleCal">
                    <img style="position: relative; top: 2px;" src="../../image/titleImg.png" alt="">
                    <span style="color:#ffffff;margin-left: 10px;">證券交易帳戶協議書</span>
                </div>
                <div class="pdfView">
                    <pdf ref="pdf" v-for="i in numPages" :key="i" :page="i" :src="pdfUrl" @page-loaded="pageLoad"/>
                </div>
                <div :class="['pdfProgressView',percentageShow ? '' : 'disNone']">
                    <el-progress class="progressIn" :text-inside="true" :stroke-width="26" :percentage="percentageNum"></el-progress>
                </div> -->
                <br>
    
            </div>
            <div style="position: fixed;bottom: 9%;right: 34%;">
                <button @click="agreeEvent" :class="['agreeBtn', btnUse ? '' : 'unUse']">{{this.$t('khxy.tygxy')}}</button>
            </div>
            <language></language>
        </div>
	</div>
   
</template>
<script>

    import pdf from 'vue-pdf';

    import https from '@/plugins/http.js';

    import apiUrl from '@/assets/api.js';

    import App from '@/assets/app.js';

    import account from '../accountOpening/account.vue'

    import directory from "@/components/directory";

     import language from '../main/mains.vue';

    export default {
        data() {
            return {
                numPages:0,
                ifEnglish : localStorage.getItem('lang') == 'eng' ? true : false,
                pdfUrlE:'https://hk.qmisit.com:3785/kaihu/getFileLook?filename=khzhxy_en.pdf',
                pdfUrlZ:'https://hk.qmisit.com:3785/kaihu/getFileLook?filename=khzhxy.pdf',
                percentageNum:0,
                percentageShow:true,
                timer:'',
                btnUse:false,
            }
        },
        components:{
            pdf,
            account,
			directory,
            language

        },
        created(){
            this.pdfTask(this.ifEnglish ? this.pdfUrlE :  this.pdfUrlZ);
            this.progressFn();
        },
        mounted() {
            this.box = this.$refs.viewBox;
            console.log(this.box)
            this.box.addEventListener('scroll', this.scollFn, false);
        },
        methods: {
            pdfTask(pdfUrl){
                var _this = this;
                var loadingTask = pdf.createLoadingTask(pdfUrl)  
                loadingTask.promise.then(pdf => {
                    _this.pdfUrl = loadingTask;
                    _this.numPages = pdf.numPages;
                }).catch((err) => {
                    console.error('pdf加载失败' + err)
                })
            },
            pageLoad(){
                let _this = this;
                _this.percentageNum = 100
                clearInterval(_this.timer);
                setTimeout(()=>{
                    _this.percentageShow = false;
                },500);
            },
            progressFn(){
                let _this = this;
                _this.timer = setInterval(()=>{
                    if( _this.percentageNum < 100){
                        _this.percentageNum ++;
                    }
                    
                },100)
            },
            scollFn(){
                let _this = this;
                let scrollTop = _this.$refs.viewBox.scrollTop;
                let scrollHeight = _this.$refs.viewBox.scrollHeight;
                let onePageHeight = scrollHeight/_this.numPages;
                if(scrollHeight - (scrollTop+onePageHeight) < 200){
                    _this.btnUse = true;
                }
            },
            agreeEvent(){
                let _this = this;
                if(_this.btnUse){
                    let json = {
                        token : _this.$store.state.token,
                    }
                    https.fetchLoginPost(apiUrl.register,{
                        token:json.token,
                        language:localStorage.getItem('lang')
                    }).then((data) => {
                        if(Object.is(data.qmiscode,1000)){
                            _this.$router.push({path: '/main/accountOpeningType'});
                        }else if(Object.is(data.qmiscode,3000) || Object.is(data.qmiscode,2000)){
                            App.oTool.warningT(data.qmismsg)
                            setTimeout(() => {
                                _this.$router.replace("/")
                            }, 1500);
                        }else{
                            App.oTool.warningT(data.qmismsg)
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }
            }
        },
    };

</script>


